import React from 'react';
import { KanbanItem } from '@clareefai/types';

interface Column {
  id: string;
  title: string;
  items: KanbanItem[];
  color: string;
  headerColor?: string;
  subtitle?: string;
  /** Body background (e.g. 'bg-blue-100'). Uses column.color if not set. */
  bodyColor?: string;
  /** Border color for the column (hex, e.g. '#3b82f6') */
  borderColor?: string;
}

interface KanbanBoardProps {
  columns: Column[];
  renderCard: (item: KanbanItem) => React.ReactNode;
}

const KanbanBoard: React.FC<KanbanBoardProps> = ({ columns, renderCard }) => {
  return (
    <div className="kanban-board">
      {columns.map((column) => (
        <div
          key={column.id}
          className="kanban-column"
          style={column.borderColor ? { borderColor: column.borderColor } : undefined}
        >
          <div className={`flex-shrink-0 p-3 border-b rounded-t-xl ${column.headerColor ? `${column.headerColor} text-white` : 'bg-gray-50'}`}>
            <div className="flex items-center justify-between">
              <div>
                <h3 className={`font-semibold text-sm ${column.headerColor ? 'text-white' : 'text-gray-800'}`}>
                  {column.title}
                </h3>
                {column.subtitle && (
                  <p className={`text-xs mt-1 ${column.headerColor ? 'text-white opacity-90' : 'text-gray-600'}`}>
                    {column.subtitle}
                  </p>
                )}
              </div>
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                column.headerColor
                  ? 'bg-white bg-opacity-20 text-white'
                  : column.color
              }`}>
                {column.items.length}
              </span>
            </div>
          </div>

          <div className={`flex-1 p-3 min-h-0 kanban-column-body ${column.bodyColor || column.color}`}>
            {column.items.map((item) => (
              <div key={item.id} className="kanban-card">
                {renderCard(item)}
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default KanbanBoard;
